export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGOUT = "LOGOUT";

export const HOME_VIDEOS_REQUEST = "HOME_VIDEOS_REQUEST";
export const HOME_VIDEOS_SUCCESS = "HOME_VIDEOS_SUCCESS";
export const HOME_VIDEOS_FAILURE = "HOME_VIDEOS_FAILURE";

export const SELECTED_VIDEO_REQUEST = "SELECTED_VIDEO_REQUEST";
export const SELECTED_VIDEO_SUCCESS = "SELECTED_VIDEO_SUCCESS";
export const SELECTED_VIDEO_FAILURE = "SELECTED_VIDEO_FAILURE";

export const SEARCHED_VIDEOS_REQUEST = "SEARCHED_VIDEO_REQUEST";
export const SEARCHED_VIDEOS_SUCCESS = "SEARCHED_VIDEO_SUCCESS";
export const SEARCHED_VIDEOS_FAILURE = "SEARCHED_VIDEO_FAILURE";

export const CHANNEL_VIDEOS_REQUEST = "CHANNEL_VIDEOS_REQUEST";
export const CHANNEL_VIDEOS_SUCCESS = "CHANNEL_VIDEOS_SUCCESS";
export const CHANNEL_VIDEOS_FAILURE = "CHANNEL_VIDEOS_FAILURE";

export const RELATED_VIDEO_REQUEST = "RELATED_VIDEO_REQUEST";
export const RELATED_VIDEO_SUCCESS = "RELATED_VIDEO_SUCCESS";
export const RELATED_VIDEO_FAILURE = "RELATED_VIDEO_FAILURE";

export const CHANNEL_DETAILS_REQUEST = "CHANNEL_DETAILS_REQUEST";
export const CHANNEL_DETAILS_SUCCESS = "CHANNEL_DETAILS_SUCCESS";
export const CHANNEL_DETAILS_FAILURE = "CHANNEL_DETAILS_FAILURE";
export const SET_SUBSCRIPTION_STATUS = "SET_SUBSCRIPTION_STATUS";

export const SUBSCRIPTION_LIST_REQUEST = "SUBSCRIPTION_LIST_REQUEST";
export const SUBSCRIPTION_LIST_SUCCESS = "SUBSCRIPTION_LIST_SUCCESS";
export const SUBSCRIPTION_LIST_FAILURE = "SUBSCRIPTION_LIST_FAILURE";

export const COMMENT_LIST_REQUEST = "COMMENT_LIST_REQUEST";
export const COMMENT_LIST_SUCCESS = "COMMENT_LIST_SUCCESS";
export const COMMENT_LIST_FAILURE = "COMMENT_LIST_FAILURE";

export const CREATE_COMMENT_SUCCESS = "CREATE_COMMENT_SUCCESS";
export const CREATE_COMMENT_FAILURE = "CREATE_COMMENT_FAILURE";
